module.exports = __webpack_public_path__ + "static/media/22ESCWA7.08c49559.jpg";